import {
    Create,
    Edit,
    List,
    AdminList,
    Show,
    BulkCreate,
    Card,
    ShowAllCard,
    ApprovedList,
    New,
    OldEntry,
    EarlyJoin,
    LeaveExtension,
    Correction,
    ShowCorrection,
    Current,
} from "../Components/index.js";

export default [
    {
        path: "/leave-approval",
        component: List,
        name: "leave",
        props: (route) => ({
            to: route.query.status,
            stage: route.query.stage,
            bg: route.query.bg,
        }),

        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/leave-list",
        component: AdminList,
        name: "leave.list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/leave-approved",
        component: ApprovedList,
        name: "leave.approved",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/my-leave-approved",
        component: ApprovedList,
        name: "my.leave.approved",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/leave/entry",
        component: Create,
        name: "leave.entry",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/leave/new",
        component: New,
        name: "leave.new",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/leave/other-new",
        component: New,
        name: "leave.other.new",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/leave/extension",
        component: LeaveExtension,
        name: "leave.extension",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/leave/old",
        component: OldEntry,
        name: "leave.old",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/leave/my-old",
        component: OldEntry,
        name: "my.old.leave",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/leave/current",
        component: Current,
        name: "my.current.leave",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/leave/bulk-entry",
        component: BulkCreate,
        name: "leave.bulk.entry",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/leave/:id/show",
        component: Show,
        name: "leave.show",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/leave/:id/edit",
        component: Edit,
        name: "leave.edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/leave/:id/card",
        component: Card,
        name: "leave.card",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/leave/show/all-card",
        component: ShowAllCard,
        name: "leave-show-all-card",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/leave-early-join",
        component: EarlyJoin,
        name: "report.leave.early.join",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/leave/correction",
        component: Correction,
        name: "leave.correction",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/leave/show-correction/:id",
        component: ShowCorrection,
        name: "leave.show.correction",
        meta: {
            requiresAuth: true,
        },
    },
];
